import {RegulatoryDocumentParagraph} from 'types';
import {Selection} from 'components/FluentUICompat';
import {Check, Theme} from '@fluentui/react';
import {RenderEditCellProps} from 'react-data-grid';
import {IRow} from './GridViewRows';
import {
	renderCellHighlightSTD,
	renderCheckbox,
	renderEditCellSTD,
} from './GridViewCells';
import {EntityListColumn} from '../EntityList';
import {DataStoreGridChangedCells} from './GridView';

export interface GridViewColumn {
	key: string;
	name: string;
	minWidth: number;
	width: number;
	maxWidth?: number;
	editable?: boolean;
	resizable?: boolean;
	frozen?: boolean;
	columnType: GridViewColumnType;
	calloutForm?: JSX.Element;
	noCalloutForm?: boolean;
	renderCell?: ({row}: {row: IRow}) => JSX.Element;
	renderEditCell?: ({row, onClose}: RenderEditCellProps<IRow>) => JSX.Element;
}

export interface GridViewChangedColumn {
	key: string;
}

export enum GridViewColumnType {
	Array,
	Date,
	Phase,
	Text,
	HTML,
	Other,
}

export const columnsGridView = (
	columns: GridViewColumn[],
	entityListColumns: EntityListColumn[],
	dsChangedCells: DataStoreGridChangedCells,
	selection: React.RefObject<Selection<IRow>>,
	handleLocalChange: (col: GridViewColumn, row: IRow) => () => Promise<void>,
	theme: Theme,
) => {
	const fnCheckbox = () => renderCheckbox(selection);
	const columnSelection = {
		key: 'checkbox',
		name: '',
		columnType: GridViewColumnType.Other,
		minWidth: 40,
		maxWidth: 40,
		width: 40,
		editable: false,
		frozen: true,
		renderCell: fnCheckbox(),
	};

	const visibleColKeys = new Set(entityListColumns.map(x => x.fieldName));
	const visibleColumns = columns
		.filter(col => visibleColKeys.has(col.key))
		.map(col => ({
			...col,
			renderCell: renderCellHighlightSTD(col, dsChangedCells, theme),
		}));

	const columnsGrid: GridViewColumn[] = [columnSelection, ...visibleColumns];

	return columnsGrid.map((col, ii) => {
		const renderEditCell = renderEditCellSTD(ii, col, handleLocalChange);
		return {...col, renderEditCell};
	});
};
